import { Clientize, SystemLossThresholds, SystemLossThresholdsValue } from 'types';

import { api } from './api';

export interface SystemLossThresholdsHistoryDiff {
  path: string;
  from?: unknown;
  to?: unknown;
}

export interface SystemLossThresholdsHistoryEntry {
  timestamp: string;
  actorEmail?: string;
  diffs: SystemLossThresholdsHistoryDiff[];
}

export interface SystemLossThresholdsHistoryResponse {
  data: SystemLossThresholdsHistoryEntry[];
  total: number;
}

interface GetSystemLossThresholdsHistoryParams {
  limit?: number;
  offset?: number;
}

export const systemLossThresholdsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getSystemLossThresholds: build.query<Clientize<SystemLossThresholds>, void>({
      query: () => ({ url: '/system-loss-thresholds' }),
      providesTags: [{ type: 'SystemLossThresholds', id: 'CURRENT' }],
    }),
    updateSystemLossThresholds: build.mutation<Clientize<SystemLossThresholds>, SystemLossThresholdsValue>({
      query: (value) => ({
        url: '/system-loss-thresholds',
        method: 'PUT',
        body: { value },
      }),
      invalidatesTags: [
        { type: 'SystemLossThresholds', id: 'CURRENT' },
        { type: 'SystemLossThresholds', id: 'HISTORY' },
      ],
    }),
    getSystemLossThresholdsHistory: build.query<
      SystemLossThresholdsHistoryResponse,
      GetSystemLossThresholdsHistoryParams | void
    >({
      query: (params) => {
        const searchParams = new URLSearchParams();
        if (params?.limit !== undefined) searchParams.set('limit', String(params.limit));
        if (params?.offset !== undefined) searchParams.set('offset', String(params.offset));
        const qs = searchParams.toString();
        return { url: `/system-loss-thresholds/history${qs ? `?${qs}` : ''}` };
      },
      providesTags: [{ type: 'SystemLossThresholds', id: 'HISTORY' }],
    }),
  }),
});

export const {
  useGetSystemLossThresholdsQuery,
  useUpdateSystemLossThresholdsMutation,
  useGetSystemLossThresholdsHistoryQuery,
} = systemLossThresholdsApi;
